export default __webpack_public_path__ + "static/media/Union_right.809c0b89.svg";